import React, { useState } from 'react';
import { Formik, Form } from 'formik';

import {
  AssetCard,
  Button,
  Input,
  Select,
  GridView,
  AssetListCard,
} from 'components/common';
import AssetCardImg from 'assets/images/asset-card.svg';

const Favourites = () => {
  const assets: any = [];

  const setOpen = () => {};

  const [activeGrid, setActiveGrid] = useState<string>('grid');

  return (
    <div>
      <div className="flex justify-between flex-col sm:flex-row">
        <Formik initialValues={{ searchParams: '' }} onSubmit={() => setOpen()}>
          <Form>
            <Input
              className="bg-transparent border border-primary-2 outline-0 py-2 rounded-2xl text-white xl:min-w-[300px] xl:min-w-[456px] px-4"
              placeholder="Search lands, apartments and buildings"
            />
          </Form>
        </Formik>

        <Formik initialValues={{ sortBy: '' }} onSubmit={() => setOpen()}>
          <Form className="mt-4 sm:mt-0">
            <Select
              placeholder="Sort by"
              className="bg-transparent border border-primary-2 py-2 px-3 rounded-2xl min-w-[230px] focus:outline-none text-white"
              type="select"
              name="sortBy"
            >
              <option value="name">Name</option>
              <option value="date">Date</option>
            </Select>
          </Form>
        </Formik>
      </div>

      <div className="flex justify-end">
        <GridView setActiveGrid={setActiveGrid} activeGrid={activeGrid} />
      </div>

      {activeGrid === 'grid' ? (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-12">
          {new Array(6).fill(1).map((index) => (
            <AssetCard
              propertySlug="s"
              address="s"
              key={index}
              img={AssetCardImg}
              title="BANA ISLAND"
              description="Located beside the house of the richest man in Africa."
              price="1,157,400 (750,000 USDC) "
              favourite
            />
          ))}
        </div>
      ) : (
        <>
          <div className="grid grid-cols-ourTable gap-3 py-4 border-y border-white/20">
            <p className="text-white text-xl">Assets</p>
            <p className="text-white text-xl">Description</p>
            <p className="text-white text-xl">Listed Price</p>
            <p>.</p>
          </div>
          {new Array(6).fill(1).map((index, i) => (
            <AssetListCard
              key={index}
              propertySlug="s"
              address="s"
              img={AssetCardImg}
              title="BANA ISLAND"
              description="Located beside the house of the richest man in Africa."
              price="1,157,400 (750,000 USDC) "
              favourite
            />
          ))}
        </>
      )}

      <div className="flex justify-center mt-12">
        <Button type="button" variant="primary">
          View More
        </Button>
      </div>
    </div>
  );
};

export default Favourites;
